"use strict";
exports.__esModule = true;
exports.RxpPreOnboardingAugustBpExperiment = exports.RxpPreOnboardingAugustBpVariantValues = void 0;
var types_1 = require("../types");
// Pre-onboarding experiment for August BP
// Shows either carousel or single screen welcome variants
var RxpPreOnboardingAugustBpVariantValues;
(function (RxpPreOnboardingAugustBpVariantValues) {
    RxpPreOnboardingAugustBpVariantValues["Carousel"] = "carousel";
    RxpPreOnboardingAugustBpVariantValues["SingleScreen"] = "single_screen";
})(RxpPreOnboardingAugustBpVariantValues = exports.RxpPreOnboardingAugustBpVariantValues || (exports.RxpPreOnboardingAugustBpVariantValues = {}));
exports.RxpPreOnboardingAugustBpExperiment = {
    variantID: 'rxp-pre-onboarding-august-bp',
    controlValue: types_1.CONTROL,
    variantValues: RxpPreOnboardingAugustBpVariantValues
};
